import { WSAlert } from "@wingspanhq/fe-component-library";
import { IBulkBatch } from "@wingspanhq/payments/dist/interfaces";
import pluralize from "pluralize";
import { useDownloadSkippedRows } from "../../hooks/useDownloadSkippedRows";
import { BulkResource } from "../../types";
import { getUploadRejectedRowsCount } from "../../utils/bulkBatchUtils";

type Props = {
  bulkBatch: IBulkBatch;
  bulkResource: BulkResource;
};

/**
 * Rows Flatfile rejected while uploading the spreadsheet never became batch items, so they are
 * silently missing from the import. This alert makes them visible and downloadable.
 */
export const BulkBatchUploadUnuploadedRowsAlert: React.FC<Props> = ({
  bulkBatch,
  bulkResource
}) => {
  const rejectedRowsCount = getUploadRejectedRowsCount(bulkBatch);
  const downloadSkippedRows = useDownloadSkippedRows(bulkBatch, bulkResource);

  if (!rejectedRowsCount) {
    return null;
  }

  return (
    <WSAlert
      theme="warning"
      icon="alert"
      name="uploadRejections"
      title="Some rows could not be uploaded"
      action={{
        text: "Download skipped rows",
        onClick: downloadSkippedRows
        // onAsyncClick: downloadSkippedRows
      }}
    >
      {pluralize("row", rejectedRowsCount, true)} rows could not be uploaded and
      were not imported. You can correct these rows and upload them separately.
    </WSAlert>
  );
};
